const ALPHABET = '0123456789ABCDEFGHJKMNPQRSTVWXYZ';
const ULID = /^[0-9A-HJKMNP-TV-Z]{26}$/;

/** The request id is a ULID. Its first ten characters are when it was asked. */
export function askedAt(id: string): Date | null {
  if (!ULID.test(id)) return null;
  let ms = 0;
  for (let i = 0; i < 10; i++) ms = ms * 32 + ALPHABET.indexOf(id[i]!);
  const at = new Date(ms);
  return Number.isNaN(at.getTime()) ? null : at;
}

export function isAwaitingSecondPerson(body: unknown): boolean {
  if (body === null || typeof body !== 'object') return false;
  const row = body as { status?: unknown; approval_request_id?: unknown };
  return row.status === 'PENDING'
    && typeof row.approval_request_id === 'string'
    && row.approval_request_id !== '';
}

export function isOwnRequest(requestedBy: string, userId: string | undefined): boolean {
  return userId !== undefined && requestedBy === userId;
}

/** Someone else decided this merge between the list and the press. */
export function alreadyDecided(error: unknown): boolean {
  return typeof error === 'object' && error !== null
    && 'status' in error && (error as { status: unknown }).status === 409;
}
